var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.77 17.66-.72-.96H9.9c-2.02 0-3.9-.47-3.9-3.9v-2.63C6 7.86 7.19 6.49 9.34 6.3c.16-.02.35-.03.56-.03h4.2c2.51 0 3.9 1.38 3.9 3.9v2.63c0 .2-.01.4-.03.58-.18 2.12-1.55 3.31-3.86 3.31h-.15l-.72.96c-.32.43-.77.66-1.24.66s-.92-.24-1.23-.65zM9.5 7.81c-1.41.12-2 .83-2 2.38v2.63c0 2.07.57 2.4 2.4 2.4h.26c.38 0 .79.2 1.02.5l.79 1.06.85-1.05c.24-.32.62-.51 1.02-.51h.26c1.55 0 2.25-.59 2.37-1.97.02-.16.02-.29.02-.43v-2.63c0-1.68-.72-2.4-2.4-2.4H9.9c-.14 0-.27 0-.4.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-circle.64a45822003de37b8ce16131f117d872.svg";
export { ForwardRef as ReactComponent };